import {
  useTonConnectUI,
  useTonAddress,
  // useTonWallet
} from "@tonconnect/ui-react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { updateProfile } from "../../../../lib/store/actions";
import { useEffect, useRef, useState } from "react";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../../hooks/useLanguage";
// import UnclaimedPopModal from '../../../../components/Modals/UnclaimedPop';

export default function WalletButton() {
  // const { t } = useTranslation();
  const t = useLanguage();

  const [tonConnectUI] = useTonConnectUI();
  // const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  // const wallet = useTonWallet();
  const userFriendlyAddress = useTonAddress();
  const dispatch = useDispatch();
  const { user: userData } = useSelector(({ Auth }) => Auth);

  const handleConnect = async () => {
    await tonConnectUI.openModal();
    // console.info("open modal connected", tonConnectUI?.connected, userFriendlyAddress);
  };

  const handleDisconnect = async () => {
    try {
      // console.info("connected", tonConnectUI?.connected, userFriendlyAddress);
      setLoading(true);
      if (tonConnectUI?.connected) {
        await tonConnectUI.disconnect();
      }
      if (userData?._id) {
        dispatch(
          updateProfile({
            data: {
              _id: userData._id,
              walletAddress: null,
              isWalletConnected: false,
            },
            callBack: (err, data) => {
              if (err) {
                // console.error('Error updating profile:', err);
                return;
              }
              setLoading(false);
            },
          }),
        );
      }
    } catch (error) {
      // console.error("Disconnect failed", error);
      if (userData?._id) {
        dispatch(
          updateProfile({
            data: {
              _id: userData._id,
              walletAddress: null,
              isWalletConnected: false,
            },
            callBack: (err, data) => {
              if (err) {
                // console.error('Error updating profile:', err);
                return;
              }
              setLoading(false);
            },
          }),
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const debouncedUpdateProfileRef = useRef(
    debounce((walletAddress, userId, dispatch) => {
      if (userId) {
        dispatch(
          updateProfile({
            data: {
              _id: userId,
              walletAddress: walletAddress,
              isWalletConnected: true,
            },
            callBack: (err, data) => {
              if (err) {
                // console.error('Error updating profile:', err);
                return;
              }
            },
          }),
        );
      }
    }, 100),
  );

  useEffect(() => {
    // console.info("userFriendlyAddress ======>", userFriendlyAddress);
    if (userFriendlyAddress && userData?._id && !userData?.walletAddress) {
      debouncedUpdateProfileRef.current(
        userFriendlyAddress,
        userData._id,
        dispatch,
      );
    }
  }, [userFriendlyAddress, userData, dispatch]);

  return (
    <>
      <div className="text-center mx-auto" style={{ maxWidth: 295 }}>
        {!userData?.walletAddress ? (
          <Button
            onClick={handleConnect}
            style={{ height: "50px", background: "#0593f4" }}
            type="button"
            className="d-inline-flex align-items-center w-100 fw-bold justify-content-center commonBtn border-0 my-1 btn btn-primary"
          >
            {t("wallet_page.wallet_tab.connect_telegram")}
          </Button>
        ) : (
          <div className="text-center ">
            <Button
              className="d-inline-flex align-items-center w-100 fw-bold justify-content-center commonBtn border-0 my-1 btn btn-primary"
              onClick={handleDisconnect}
              style={{ height: "50px", background: "#02bcc0" }}
              type="button"
              disabled={loading}
            >
              {loading
                ? `${t("wallet_page.wallet_tab.disconnect")}...`
                : t("wallet_page.wallet_tab.disconnect_telegram_wallet")}
            </Button>
          </div>
        )}
      </div>
    </>
  );
}
